async function o(t) {
  const a = new TextEncoder().encode(t), r = await crypto.subtle.digest("SHA-256", a);
  return Array.from(new Uint8Array(r)).map((e) => e.toString(16).padStart(2, "0")).join("");
}
export {
  o as default
};
